import { render, staticRenderFns } from "./card-hospitalization.vue?vue&type=template&id=21aaa6bc"
import script from "./card-hospitalization.vue?vue&type=script&lang=js"
export * from "./card-hospitalization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports